<script lang="ts">
  import { fade, fly } from 'svelte/transition';
  import type { Palette } from '../../theme.svelte';

  let {
    open = false,
    title = '',
    message = '',
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    palette,
    isDanger = false,
    onConfirm,
    onCancel,
  }: {
    open: boolean;
    title: string;
    message: string;
    confirmLabel: string;
    cancelLabel: string;
    palette: Palette;
    isDanger: boolean;
    onConfirm: () => void;
    onCancel: () => void;
  } = $props();
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_static_element_interactions -->
{#if open}
  <div
    class="modal-backdrop"
    onclick={onCancel}
    transition:fade={{ duration: 150 }}
  >
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div
      class="modal-card"
      onclick={(e) => e.stopPropagation()}
      transition:fly={{ y: 12, duration: 150 }}
      style={`background-color: ${palette.userMenuBg}; color: ${palette.textPrimary}; border-color: ${palette.borderSoft};`}
    >
      <h3 class="modal-title">{title}</h3>
      <p class="modal-message" style="color: {palette.textSecondary};">{message}</p>
      <div class="modal-actions">
        <button
          class="modal-btn cancel"
          onclick={onCancel}
          style={`background-color: ${palette.userMenuHover}; color: ${palette.textPrimary};`}
        >
          {cancelLabel}
        </button>
        <button
          class="modal-btn confirm {isDanger ? 'danger' : ''}"
          onclick={onConfirm}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal-card {
    border-radius: 12px;
    padding: 24px;
    max-width: 400px;
    width: 90%;
    border: 1px solid;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  }

  .modal-title {
    margin: 0 0 8px;
    font-size: 16px;
    font-weight: 600;
  }

  .modal-message {
    margin: 0 0 20px;
    font-size: 14px;
    line-height: 1.5;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .modal-btn {
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: opacity 0.15s ease;
  }

  .modal-btn:hover {
    opacity: 0.85;
  }

  .modal-btn.confirm {
    background-color: #40b0ff;
    color: #fff;
  }

  .modal-btn.confirm.danger {
    background-color: #ef4444;
    color: #fff;
  }

  @media (max-width: 768px) {
    .modal-card {
      padding: 20px;
    }

    .modal-title {
      font-size: 15px;
    }

    .modal-message {
      font-size: 13px;
    }

    .modal-btn {
      padding: 8px 14px;
      font-size: 13px;
    }
  }

  @media (max-width: 480px) {
    .modal-card {
      padding: 16px;
      width: 95%;
    }
  }
</style>
